import { createFileRoute } from '@tanstack/react-router'
import RegisterVerificationCode from '../../../../containers/register-verification-code'

export const Route = createFileRoute('/_unauthenticated/register/verification-code/')({
    component: RegisterVerificationCode
})
